import { colors } from "colors"
import { useWindowDimensions } from "react-native"

const useResponsiveWidth = () => {
  const { width } = useWindowDimensions()

  const getResponsiveWidth = () => {
    if (width >= 800) {
      return {
        width: colors.appMaxWidth,
      }
    } else {
      return {
        width,
      }
    }
  }

  return getResponsiveWidth
}

export default useResponsiveWidth
